
import React, {useState} from 'react'
import { useTranslation } from 'react-i18next'
import { Button, Card, CardBody, Col, Label, Modal, ModalBody, ModalHeader, Row } from 'reactstrap'

const Pictures = ({ vehicleInspectionPictures }) =>
{
    const { t } = useTranslation()
    const [selectedPicFilePath, setSelectedPicFilePath] = useState('')

    const handleSmallInspectionPicClicked = (filePath) =>
    {
        setSelectedPicFilePath(filePath)
    }

    const handleLargeInspectionPicClicked = () =>
    {
        setSelectedPicFilePath('')
    }

    return (
        <>
            <Row>
                <Col md="12">
                    <Row>
                        {vehicleInspectionPictures.map((picture, idx) => (
							<Col key={ idx } sm="1" style={{ marginBottom: '10px' }}>
								<img
									key={ idx }
									className="inspection-pic-sm"
									src={ picture.filePath }
									width="100px"
									height="100px"
									alt="..."
									onClick={ () => { handleSmallInspectionPicClicked(picture.filePath) } }
									style={{ cursor: 'pointer' }}
								/>
							</Col>
                        ))}
                    </Row>
                    {
                        vehicleInspectionPictures.length === 0 &&
                        <Row style={{ marginTop: '20px' }}>
                            <Col md="12" style={{ textAlign: 'center' }}>
                                <Label>{ t('Auctions.Pictures.No_Results') }</Label>
                            </Col>
                        </Row>
                    }
                </Col>
            </Row>

			<Modal
				size="lg"
				isOpen={selectedPicFilePath.length > 0}
				toggle={() => handleLargeInspectionPicClicked()}
			>
				<ModalHeader toggle={ () => handleLargeInspectionPicClicked() } charCode="Y"></ModalHeader>
				<ModalBody>
					<Card className="border-0 mb-0">
						<CardBody>
							<div className="text-center">
								<img className="inspection-pic-lg" src={selectedPicFilePath} width="700px" height="600px" alt="..."/>
							</div>
							<div className="text-center">
								<Button
									className="my-4"
									color="primary"
									type="button"
									onClick={() => handleLargeInspectionPicClicked()}
									style={{ marginLeft: '10px' }}
								>
									Close
								</Button>
							</div>
						</CardBody>
					</Card>
				</ModalBody>
			</Modal>
        </>
    )
}

export default Pictures
